import { render, staticRenderFns } from "./Shichituan.vue?vue&type=template&id=795b1d8b&scoped=true&"
import script from "./Shichituan.vue?vue&type=script&lang=js&"
export * from "./Shichituan.vue?vue&type=script&lang=js&"
import style0 from "./Shichituan.vue?vue&type=style&index=0&id=795b1d8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b1d8b",
  null
  
)

export default component.exports